module.exports = __webpack_public_path__ + "static/media/piano-player.ab57af58.jpeg";